export default {
  login: {
    labels: {
      prefixLogin: 'ล็อกอินภายใต้ทีม',
      subfixLogin: '',
      dontHaveAccount: 'หากคุณยังไม่มีบัญชีผู้ใช้ ?',
      dontHaveAccountOnTeam: 'หากต้องการสมัครใช้งานภายใต้ทีมนี้',
      contactTeamAdmin: 'กรุณาติดต่อแอดมินของทีมเพื่อสร้างบัญชีผู้ใช้ให้คุณ',
    },
    action: {
      enterTeamURL: 'กรุณากรอก Team URL ของคุณ',
      registerNewAccount: 'สมัครใช้งาน',
      chooseYourTeam: 'เลือกทีมที่ต้องการเข้าใช้งาน',
      loginOtherTeam: 'ล็อคอินภายใต้ทีมอื่น',
    },
    response: {
      failed: 'ขออภัย คุณกรอกอีเมลหรือรหัสผ่านผิด กรุณาลองใหม่อีกครั้ง',
    },
  },
  register: {
    labels: {
      register: 'สมัครใช้งาน',
      acceptTerm: 'คุณอ่านและยอมรับใน',
      termOfService: 'ข้อกำหนดการใช้งาน',
    },
    action: {
      registerSuccess: 'สมัครใช้งานเรียบร้อย',
      finish: 'สำเร็จ',
    },
    failed: 'มีความผิดพลาดเกิดขึ้น กรุณาลองใหม่อีกครั้ง',
    success: 'กรุณากดยืนยันตัวตนจากอีเมลที่เพิ่งถูกส่งไปยัง ',
  },
  forgot: {
    labels: {
      forgotPassword: 'หากคุณลืมรหัสผ่าน',
      prefixResetPassword: 'กรุณากรอกอีเมลที่คุณเคยสมัครใช้งานภายใต้ทีม',
      subfixResetPassword: '',
    },
    action: {
      forgotPassword: 'ลืมรหัสผ่าน ?',
      sendRequest: 'ส่งลิงก์สำหรับรีเซ็ตรหัสผ่าน',
    },
    response: {
      success: 'ลิงก์สำหรับรีเซ็ตรหัสผ่านถูกส่งไปยังอีเมลเรียบร้อยแล้ว',
      failed: 'ไม่พบัญชีผู้ใช้จากอีเมล์ที่คุณระบุ กรุณาลองใหม่อีกครั้งหรือติดต่อผู้ดูแลทีมของคุณ',
      defaultFailed: 'มีความผิดพลาดเกิดขึ้น กรุณาลองใหม่อีกครั้ง',
    },
  },
  recovery: {
    labels: {
      resetPassword: 'รีเซ็ตรหัสผ่าน',
      enterNewPassword: 'กรอกรหัสผ่านใหม่สำหรับใช้ล็อคอินภายใต้ทีม',
    },
    action: {
      resetPassword: 'ยืนยันรหัสผ่านใหม่',
      continueLogin: 'ไปยังหน้าล็อคอิน',
      backToLogin: 'กลับไปยังหน้าล็อคอิน',
      resend: 'ส่งใหม่อีกครั้ง',
    },
    verifyToken: {
      response: {
        linkInvalid: 'ลิงก์รีเซ็ตรหัสผ่านไม่ถูกต้อง',
        linkExpired: 'ลิงก์รีเซ็ตรหัสผ่านนี้หมดอายุลงแล้ว กรุณากดลืมรหัสผ่านใหม่อีกครั้ง',
        defaultFailed: 'มีความผิดพลาดเกิดขึ้น กรุณาลองใหม่อีกครั้ง',
      },
    },
    resetPassword: {
      response: {
        success: 'รหัสผ่านของคุณถูกรีเซ็ตแล้ว',
        failed: 'รหัสผ่านของคุณไม่สำเร็จ กรุณาตรวจสอบข้อผิดพลาดดังต่อไปนี้',
        defaultFailed: 'มีความผิดพลาดเกิดขึ้น กรุณาลองใหม่อีกครั้ง',
      },
    },
  },
  changePassword: {
    response: {
      failed: 'ขออภัย คุณกรอกรหัสผ่านปัจจุบันผิด',
    },
  },
  contact: {
    response: {
      success: 'ข้อมูลของคุณถูกส่งเรียบร้อยแล้ว',
    },
  },
  activate: {
    verifyToken: {
      response: {
        success: 'บัญชีผู้ใช้ของคุณได้รับการยืนยันแล้ว',
        linkInvalid: 'ลิงก์ที่ใช้ในการยืนยันอีเมลไม่ถูกต้อง',
        linkExpired: 'ลิงก์ที่ใช้ในการยืนยันอีเมลนี้หมดอายุลงแล้ว กรุณาสมัครใช้งานใหม่อีกครั้ง',
        defaultFailed: 'มีความผิดพลาดเกิดขึ้น กรุณาลองใหม่อีกครั้ง',
      },
    },
  },
  menu: {
    dashboard: 'หน้าหลัก',
    billing: 'บัญชี',
    team: 'ทีม',
    reseller: 'Reseller',
    admin: 'Admin',
    profile: 'บัญชีผู้ใช้',
    password: 'เปลี่ยนรหัสผ่าน',
    support: 'ช่วยเหลือ',
    logout: 'ออกจากระบบ',
    services: 'Services',
    general: 'ข้อมูลทั่วไป',
    clientUsageHistory: 'ประวัติการใช้งานลูกค้า',
    addons: 'Add-ons Cost',
    creditTransaction: 'Credit Transaction',
  },
  title: {
    currentState: 'สถานะการใช้งาน',
    statement: 'รายการเคลื่อนไหวของบัญชี',
    DataTransfer: 'Data Transfer',
    cost: 'ค่าบริการ',
    FreeStorage: 'Free Storage',
    AdditionalStorage: 'Additional Storage',
    QoderVODEncoding: 'Qoder VOD Encoding',
    pricePlanVat: '** ราคานี้ยังไม่รวมภาษีมูลค่าเพิ่ม',
  },
  unit: {
    month: 'เดือน',
    minute: 'นาที',
    date: 'วันที่',
  },
  currentCredit: {
    lastedTransaction: 'เติมเครดิตล่าสุด',
    textGuide: 'ท่านสามารถใช้บริการของเราและชำระเงินด้วยบัตรเครดิตของ Visa, Mastercard และ JCB',
    percentageBar: 'ของเครดิตปัจจุบัน',
  },
  monthToDateCost: {
    creditNotEnough: 'ยอดการใช้งานเกินเครดิตคงเหลือ',
    nextCreditCharge: 'กำหนดชำระ',
    textGuide: 'ยังไม่มียอดการใช้งาน',
  },
  pricingPlan: {
    title: 'แพลนค่าบริการ',
  },
  action: {
    manage: 'แก้ไข',
    manageClientTeam: 'จัดการลูกค้า',
    moreDetail: 'ดูเพิ่มเติม',
    login: 'ล็อกอิน',
    continue: 'ขั้นตอนต่อไป',
    register: 'ยืนยันการสมัครใช้งาน',
    create: 'สร้าง',
    role: 'ตำแหน่ง',
    submit: 'ส่ง',
    cancel: 'ยกเลิก',
    search: 'ค้นหา',
    backTo: 'กลับสู่หน้า',
    print: 'พิมพ์',
    editInfo: 'แก้ไขข้อมูลทีม',
  },
  text: {
    total: 'รวมทั้งหมด',
    totalTeams: 'ทีมทั้งหมด',
    free: 'ฟรี',
    additional: 'ค่าส่วนเกิน',
    on: 'ในวันที่',
    or: 'หรือ',
    to: 'ถึง',
    textGuideFilter: 'ค้นหาด้วย Team name หรือ Team URL',
  },
  serviceGroups: {
    endUserServices: 'End User Services',
    developerServices: 'Developer Services',
  },
  services: {
    account: {
      name: 'Account',
      shortDescription: 'Manage your ByteArk Account',
    },
    analytics: {
      name: 'Analytics',
      shortDescription: 'Video transcoding without any setup, just upload and go!',
    },
    storage: {
      name: 'Storage',
      shortDescription: 'Upload and distributes files around the world, with Amazon S3-liked APIs.',
    },
    fleet: {
      name: 'Fleet',
      shortDescription: 'Simple but powerful CDN, to serve contents from your server to anyone.',
    },
    qoder: {
      name: 'Qoder',
      shortDescription: 'Video transcoding without any setup, just upload and go!',
    },
    player: {
      name: 'Player',
      shortDescription: 'Video transcoding without any setup, just upload and go!',
    },
    current: {
      state: 'กำลังใช้งาน',
      use: 'คุณกำลังใช้งาน',
    },
  },
  solutions: {
    vod: {
      name: 'Video On Demand Platform',
      shortDescription: 'จัดเก็บวิดีโอของคุณด้วยกลุ่มเมฆ เพิ่มประสิทธิภาพการรับชมวิดีโอจากทุกที่',
    },
    liveStraming: {
      name: 'Live Streaming Platform',
      shortDescription: 'ถ่ายทอดสดวิดีโอไปยังผู้ชมนับแสนไม่ใช่สิ่งที่เพ้อฝันเกินไปแน่นอน',
    },
    webCDN: {
      name: 'Web CDN',
      shortDescription: 'เร่งความเร็วให้กับเว็บไซต์ของคุณ โดยการทำ Caching เนื้อหาบนเว็บไซต์',
    },
    fileDistributor: {
      name: 'File Distributor',
      shortDescription: 'ไม่ว่าจะเป็น ไฟล์เกมส์ แพทช์เกมส์ รูปภาพ ให้เราช่วยคุณส่งต่อไปยังผู้เล่นของคุณได้ง่ายๆ',
    },
  },
  mainHeaderGroups: {
    services: 'Services',
    quickStart: 'เริ่มต้นใช้งาน',
    solutions: 'Solutions',
  },
  quickStart: {
    howToLiveStream: {
      name: 'วิธีการถ่ายทอดสดออนไลน์ (Live Streaming)',
      shortDescription: 'Video transcoding without any setup, just upload and go!',
    },
    howToUploadVdo: {
      name: 'วิธีการเผยแพร่คลิปวิดีโอ',
      shortDescription: 'Video transcoding without any setup, just upload and go!',
    },
    howToUploadFileToCDN: {
      name: 'วิธีการอัพโหลดไฟล์เพื่อแจกจ่ายให้ผู้ใช้จำนวนมาก',
      shortDescription: 'Video transcoding without any setup, just upload and go!',
    },
    howToImplementCDN: {
      name: 'วิธีเปิดใช้ CDN สำหรับเว็บไซต์ของท่าน',
      shortDescription: 'Video transcoding without any setup, just upload and go!',
    },
    howToAddCredit: {
      name: 'วิธีการชำระเงิน โดยการเติมเครดิตผ่านบัตรเครดิต',
      shortDescription: 'Video transcoding without any setup, just upload and go!',
    },
  },
  billing: {
    currencies: {
      thb: 'บาท',
    },
    labels: {
      billing: 'บัญชี',
      remainingCredits: 'เครดิตปัจจุบัน',
      currentMonthUsage: 'ค่าใช้บริการระหว่างรอบบิล',
      billingInformation: 'ที่อยู่สำหรับใบเสร็จ / ใบกำกับภาษี',
      paymentInformation: 'กรุณากรอกข้อมูลการชำระเงิน',
      perfixDiscount: 'หลังหักส่วนลด',
      subfixDiscount: 'เรียบร้อยแล้ว',
      noDiscount: 'ไม่มีส่วนลด ณ ขณะนี้',
    },
    action: {
      addCredit: 'เติมเครดิต',
      pay: 'เติม',
    },
    information: {
      labels: {
        firstname: 'ชื่อ',
        lastname: 'นามสกุล',
        companyName: 'ชื่อบริษัท',
        taxID: 'หมายเลขประจำตัวผู้เสียภาษี',
        addressLine1: 'ที่อยู่',
        addressLine2: 'ที่อยู่ (ต่อ)',
        city: 'เขต / อำเภอ',
        state: 'แขวง / จังหวัด',
        zipCode: 'รหัสไปรษณีย์',
        country: 'ประเทศ',
        billingContactPhone: 'เบอร์โทรศัพท์ที่ใช้ติดต่อ',
        billingEmail: 'อีเมลที่ใช้ติดต่อ',
        noBillingInformation: 'บัญชีนี้ยังไม่ระบุข้อมูล',
        enterBillingInformation: 'กรุณากรอกที่อยู่สำหรับใบเสร็จ / ใบกำกับภาษี',
      },
      action: {
        saveDetails: 'บันทึกข้อมูล',
        changeInformation: 'เปลี่ยนแปลงข้อมูล',
        enterBillingInformation: 'กรุณากรอกข้อมูลเพื่อใช้ในการเรียกเก็บค่าบริการ',
        addBillingInformation: 'กรอกข้อมูล',
      },
      response: {
        success: 'บันทึกข้อมูลสำเร็จแล้ว',
        failed: 'บันทึกข้อมูลไม่สำเร็จ กรุณาตรวจสอบข้อผิดพลาดดังต่อไปนี้',
        defaultFailed: 'มีความผิดพลาดเกิดขึ้น กรุณาลองใหม่อีกครั้ง',
      },
    },
    addcredit: {
      labels: {
        textGuide: 'กรุณาระบุจำนวนเครดิตที่คุณต้องการเติม',
        remark: 'หลังจากเติมเครดิตเสร็จสิ้นแล้ว คุณไม่สามารถขอคืนเครดิตได้',
      },
      paymentResult: {
        success: {
          title: 'สำเร็จ',
          text: 'เติมเครดิตเรียบร้อยแล้ว',
        },
        failed: {
          title: 'มีความผิดพลาดเกิดขึ้น',
          text: 'เติมเครดิตไม่สำเร็จ กรุณาลองใหม่อีกครั้ง',
        },
      },
    },
    payment: {
      labels: {
        creditCardNumber: 'Credit card number',
        nameOnCard: 'Name on card',
        expireMonth: 'Expire month',
        expireYear: 'Expire year',
        code: 'CVV code',
      },
    },
  },
  annoucement: {
    labels: {
      annoucements: 'Annoucements',
    },
  },
  team: {
    title: 'ข้อมูลทีม',
    labels: {
      setting: 'ตั้งค่า',
      rename: 'แก้ไขชื่อทีม',
      createTeam: 'สร้างทีม',
      editTeam: 'แก้ไขทีม',
    },
    url: {
      labels: 'Team URL',
      textGuide: '(URL นี้จะถูกใช้ถาวร)',
    },
    displayName: {
      labels: 'ชื่อทีม',
      textGuide: 'ชื่อนี้จะถูกใช้แสดงผลบนเว็บไซต์',
    },
    type: {
      labels: 'ประเภททีม',
    },
    action: {
      submit: 'แก้ไขการตั้งค่าทีม',
    },
    response: {
      success: 'บันทึกข้อมูลสำเร็จแล้ว',
      failed: 'บันทึกข้อมูลไม่สำเร็จ กรุณาตรวจสอบข้อผิดพลาดดังต่อไปนี้',
      defaultFailed: 'มีความผิดพลาดเกิดขึ้น กรุณาลองใหม่อีกครั้ง',
    },
  },
  depositcredit: {
    response: {
      success: 'เติมเครดิตเรียบร้อยแล้ว',
      failed: 'เติมเครดิตไม่สำเร็จ กรุณาตรวจสอบข้อผิดพลาดดังต่อไปนี้',
      defaultFailed: 'มีความผิดพลาดเกิดขึ้น กรุณาลองใหม่อีกครั้ง',
    },
  },
  deductcredit: {
    response: {
      success: 'หักเครดิตออกเรียบร้อยแล้ว',
      failed: 'หักเครดิตไม่สำเร็จ กรุณาตรวจสอบข้อผิดพลาดดังต่อไปนี้',
      defaultFailed: 'มีความผิดพลาดเกิดขึ้น กรุณาลองใหม่อีกครั้ง',
    },
  },
  admin: {
    billing: {
      discount: {
        response: {
          failed: 'มีความผิดพลาดเกิดขึ้น กรุณาลองใหม่อีกครั้ง',
        },
      },
    },
    pricingplan: {
      discount: {
        response: {
          failed: 'มีความผิดพลาดเกิดขึ้น กรุณาลองใหม่อีกครั้ง',
        },
      },
    },
  },
  account: {
    labels: {
      account: 'ข้อมูลผู้ใช้',
      displayName: 'ชื่อที่ใช้แสดงผล',
      email: 'อีเมล',
      password: 'รหัสผ่าน',
      existingAccount: 'หากคุณมีบัญชีผู้ใช้อยู่แล้ว กรุณา',
      role: 'ดำแหน่งของสมาชิก',
      editProfile: 'แก้ไขข้อมูลบัญชีผู้ใช้',
    },
    profile: {
      labels: {
        changeDisplayImage: 'หากคุณต้องการเปลี่ยนภาพประจำตัว สามารถเปลี่ยนได้ที่เว็บไซต์',
        chooseLanguage: 'ตั้งค่าภาษาที่ใช้แสดงผล',
      },
    },
    password: {
      labels: {
        changePassword: 'เปลี่ยนรหัสผ่าน',
        currentPassword: 'รหัสผ่านปัจจุบัน',
        newPassword: 'รหัสผ่านใหม่',
        confirmNewPassword: 'ยืนยันรหัสผ่านใหม่',
      },
    },
    activate: {
      labels: {
        activateYourAccount: 'ยืนยันบัญชีผู้ใช้ของคุณ',
      },
      action: {
        login: 'ล็อคอินที่นี่',
      },
    },
    lang: {
      th: 'ไทย',
      en: 'อังกฤษ',
    },
    action: {
      submit: 'บันทึกข้อมูล',
    },
  },
  member: {
    labels: {
      members: 'สมาชิกในทีม',
      totalMembers: 'สมาชิกทั้งหมด',
      createMember: 'สร้างสมาชิกใหม่',
      editMembers: 'แก้ไขข้อมูลสมาชิก',
    },
    action: {
      changePassword: 'แก้ไขรหัสผ่าน',
      hidePassword: 'ซ่อน',
      deactivateAccount: 'ระงับการใช้งานของบัญชีนี้',
      enableAccount: 'เปิดใช้งานบัญชีนี้',
    },
    role: {
      manager: 'Manager',
      user: {
        textGuide: '(สิทธิ์ของผู้ใช้งานประเภทนี้ จะไม่สามารถจัดการสมาชิกในทีม ตั้งค่าทีม และจัดการบัญชีได้)',
      },
    },
  },
  support: {
    labels: {
      contactUS: 'ติดต่อ ByteArk',
      subject: 'หัวข้อ',
      message: 'รายละเอียด',
      textGuide: 'หากคุณมีข้อสงสัย กรุณาส่งข้อความหาเราผ่านแบบฟอร์มด้านล่างนี้',
    },
  },
  monthlyUsageHistory: {
    labels: {
      monthlyUsageHistory: 'ค่าใช้บริการระหว่างรอบบิล',
      noUsageHistory: 'ไม่มีการใช้บริการในเดือนนี้',
    },
    action: {
      report: 'ดาวน์โหลดรายงาน',
    },
  },
  clientUsageHistory: {
    labels: {
      team: 'ชื่อทีม',
      invoiceNumber: 'หมายเลขใบแจ้งหนี้',
      usage: 'ปริมาณการใช้งาน',
      sellingPrice: 'ราคาขาย',
      discount: 'ส่วนลด',
      retailPrice: 'ราคา',
      netPrice: 'ราคาสุทธิหลังหักส่วนลด',
      noClientUsageHistory: 'ไม่มีการใช้งานในเดือนนี้',
      dateIssued: 'วันที่ออกเอกสาร',
    },
    action: {
      usageReport: 'สรุปการใช้งานรายเดือน',
      create: 'สร้าง',
    },
  },
  manageClientTeam: {
    labels: {
      name: 'ชื่อ',
      url: 'URL',
      type: 'ประเภท',
      reseller: 'Reseller',
      payPlan: 'การชำระเงิน',
    },
    action: {
      usageReport: 'สรุปการใช้งานรายเดือน',
      create: 'สร้างลูกค้าใหม่',
    },
  },
  payPlan: {
    labels: {
      postPaid: 'Post Paid',
      prePaid: 'Pre Paid',
    },
  },
  statement: {
    labels: {
      statement: 'รายการเคลื่อนไหวของบัญชี',
      orderNumber: 'หมายเลขใบรับเงิน',
      invoiceNumber: 'หมายเลขใบแจ้งหนี้',
      receiptNumber: 'หมายเลขใบเสร็จรับเงิน',
      description: 'รายละเอียด',
      amount: 'ยอดเงิน',
      noBillingHistory: 'ไม่มีความเคลื่อนไหวของบัญชีในปีนี้',
      credit: 'เครดิตที่มีอยู่',
      charge: 'หักออก',
      remaining: 'คงเหลือ',
    },
    action: {
      download: 'ดาวน์โหลดใบแจ้งหนี้',
      usageReport: 'สรุปการใช้งานรายเดือน',
      statement: 'ดูรายการเคลื่อนไหวของบัญชี',
    },
  },
  suspend: {
    labels: {
      suspend: 'บัญชีของทีมคุณถูกระงับการใช้งาน',
      defaultMessage: 'เครดิตปัจจุบันของคุณไม่พอต่อการใช้งาน กรุณาเติมเครดิตเพิ่ม',
    },
  },
};



// WEBPACK FOOTER //
// ./src/lang/th.js